import { format, subDays } from "date-fns";
import { z } from "zod";

export const reportSearchSchema = z.object({
  dateFrom: z.string().optional(),
  dateTo: z.string().optional(),
});

export function normalizeReportSearch(
  search: z.infer<typeof reportSearchSchema>,
) {
  const now = new Date();
  return {
    dateFrom: search.dateFrom ?? format(subDays(now, 30), "yyyy-MM-dd"),
    dateTo: search.dateTo ?? format(now, "yyyy-MM-dd"),
  };
}
